import React, {useContext} from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import { getTheme } from '../../theme/theme'
import { margin, SIZE } from '../../theme/metrics'

import PageMetaContext from '../../context/page-meta-context';

import ResponsiveImage from '../responsive-image'

import Button from '../button'

import { Container, Inner, ImageContainer, ImageInner, Image, ContentContainer, ContentInner, TextContainer, TextInner, TextContent, Label, Heading, Text, Buttons } from './split-cover.styles'


const SplitCover = ({color,label,heading,text,links,image}) => {
	const meta = useContext(PageMetaContext);

	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(color)})}>
			<Container>
				<Inner>
					<ContentContainer>
						<ContentInner>
							<TextContainer>
								<TextInner>
									<TextContent>
										{label && <Label>{label}</Label>}
										{heading && <Heading>
											<RichContent render={heading} />
										</Heading>}
										{text && <Text>
											<RichContent render={text} />
										</Text>}
										{links && <Buttons>
											<RichLinks render={links} block="cover" meta={meta} />
										</Buttons>}
									</TextContent>
								</TextInner>
							</TextContainer>
						</ContentInner>
					</ContentContainer>
					<ImageContainer>
						<ImageInner>
							{image && <ResponsiveImage image={image} fit="cover" sizes={{medium:{span:7,margins:1,gutters:1}}} sizeOptions={{defaultSize:`calc(100vw - ${margin(SIZE.small,{multiplier:2})})`}} />}
						</ImageInner>
					</ImageContainer>
				</Inner>
			</Container>
		</ThemeProvider>
	)
}

export default SplitCover;